import { 
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
  BACKGROUND_IMAGE_POSITION,
  PERCENTAGES,
  COMPONENT_PARALLAX_SPEED
} from 'shared/constants';

const propsSchema = [
  {
    key: 'section_tag',
    label: 'Section Tag',
    type: types.TEXT
  },
  {
    key: 'pre_title',
    label: 'Pre Title',
    type: types.TEXT
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT
  },
  {
    key: 'title_bar',
    label: 'Title Bar',
    type: types.BOOLEAN
  },
  {
    key: 'pre_description',
    label: 'Pre Description',
    type: types.TEXT
  },
  {
    key: 'description',
    label: 'Description',
    type: types.TEXT
  },
  {
    key: 'bg_color',
    label: 'Background Color',
    type: types.COLOR_PICKER
  },
  {
    key: 'theme',
    label: 'Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'desktop_img',
        label: 'Desktop Image',
        type: types.OBJECT,
        children: [
          {
            key: 'url',
            label: 'Url',
            type: types.TEXT
          },
          {
            key: 'position',
            label: 'Position',
            type: types.ENUM,
            options: BACKGROUND_IMAGE_POSITION
          },
          {
            key: 'dark_overlay',
            label: 'Dark overlay',
            type: types.ENUM,
            options: PERCENTAGES
          }
        ]
      },
    ],
  },
  {
    key: 'parallax_effect',
    label: 'Parallax Effect',
    type: types.OBJECT,
    option: false,
    children: [
      {
        key: 'enable',
        label: 'Enable',
        type: types.BOOLEAN
      },
      {
        key: 'speed',
        label: 'Speed',
        type: types.ENUM,
        options: COMPONENT_PARALLAX_SPEED
      }
    ]
  },
];

const defaultProps = {
  section_tag: 'thePowertrain',
  pre_title: 'THE POWERTRAIN',
  title: 'A Dynamic Foundation',
  title_bar: true,
  pre_description: 'Variable Platform Architecture (VPA)',
  description: 'We engineered our powertrain from the ground up to support a varied fleet of vehicles. The result was the Variable Platform Architecture (VPA) — a powerful, adaptive framework that features a modular battery structure.',
  bg_color: '#eaeaea',
  theme: 'LIGHT',
  bg_img: {
    desktop_img: {
      url: '',
      position: 'CENTER CENTER',
      dark_overlay: 0
    },
  },
  parallax_effect: {
    enable: true,
    speed: 300
  },
};

export default {
  title: 'Descriptive Intro',
  id: 'DescriptiveIntro',
  propsSchema,
  defaultProps
};
